<template>
  <div>
    <slot v-if="hasError" name="error" v-bind:err="err" v-bind:vm="vm" v-bind:info="info">
      <div class="content">
        <TriangleAlert :size="120" class="text-red-500"/>
        <h2>An unexpected error occurred.</h2>
        <p class="mt-2">Please try reloading the page, or contacting <a href="mailto:platform@cacgroup.com">platform@cacgroup.com</a>.</p>
        <div class="buttons">
          <RouterLink to="/">
            <AppButton primary>Home</AppButton>
          </RouterLink>
          <AppButton primary @click="refresh">Reload</AppButton>
        </div>
      </div>
    </slot>
    <slot v-else></slot>
  </div>
</template>

<script>
import { Commit } from '@/store';
import { StoreMutationType } from '@/types/StoreMutationType';
import { mapState } from 'vuex';
import { TriangleAlert } from '@lucide/vue';
import * as Sentry from '@sentry/vue';
import { RouterLink } from 'vue-router';
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'ErrorBoundary',
  components: {
    TriangleAlert,
    RouterLink,
    AppButton,
  },
  data: () => ({
    err: false,
    vm: null,
    info: null,
  }),
  computed: {
    ...mapState(['hasError']),
  },
  errorCaptured(err, vm, info) {
    this.err = err;
    this.vm = vm;
    this.info = info;
    Sentry.captureException(err);
    Commit(StoreMutationType.SET_HAS_ERROR, true);
    return false;
  },
  methods: {
    refresh() {
      location.reload();
    }
  }
};
</script>

<style scoped>
.content {
  display: grid;
  grid-template-columns: 0.4fr;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 80vh;
}

.content > * {
  text-align: center;
}

h2 {
  margin-top: 1em;
}

.buttons {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1rem;
}
</style>
